import * as React from 'react';
import { Dropdown, DropdownItemProps, DropdownProps } from 'semantic-ui-react';
import {
  LIBRARY_TYPE, PERFORMANCE_PLAN_EVENT_KEY_OPTIONS, READINESS_PLAN_EVENT_KEY_OPTIONS, RISK_PLAN_EVENT_KEY_OPTIONS
} from '../../../constants';
import { getOptions } from '../../../functions';
import './plan-event-mapping-options.less';

/**
 * Options for mapping "Indicator Identification"
 */
export class PlanEventMappingOptions extends React.Component<IPlanEventMappingOptionsProps> {
  constructor(props: IPlanEventMappingOptionsProps) {
    super(props);
  }

  /** Options for plan event are based on selected library type */
  public getOptions(): DropdownItemProps[] {
    const options: DropdownItemProps[] = [];

    switch (this.props.libraryType) {
      case LIBRARY_TYPE.RISK:
        options.push(...getOptions(RISK_PLAN_EVENT_KEY_OPTIONS));
        break;
      case LIBRARY_TYPE.READINESS:
        options.push(...getOptions(READINESS_PLAN_EVENT_KEY_OPTIONS));
        break;
      case LIBRARY_TYPE.PERFORMANCE:
        options.push(...getOptions(PERFORMANCE_PLAN_EVENT_KEY_OPTIONS));
        break;
      default:
        break;
    }

    return options;
  }

  public render(): JSX.Element {
    return (
      <Dropdown
        data-component="plan-event-mapping-options"
        options={this.getOptions()}
        value={this.props.planEventKey}
        onChange={this.props.onPlanEventColMappingChange}
        selectOnBlur={false}
        selection
        fluid
      />
    );
  }
}

export interface IPlanEventMappingOptionsProps {
  readonly libraryType: LIBRARY_TYPE;
  readonly planEventKey: string;
  onPlanEventColMappingChange(e: React.ChangeEvent<HTMLDivElement>, changes: DropdownProps): void;
}
